import { useEffect, useState } from 'react';
import { fromJS, List } from 'immutable';

import { IBookingEventListItemImt } from '../../interfaces';
import Services from 'services/network';
import { ICalendarSharingParams } from './useCalendarSharingParams';
import { snackbar } from 'common/utils/snackbarUtils';

interface IEventsListResult {
  data: List<IBookingEventListItemImt>;
  isLoading: boolean;
}

export function useEventListQuery(params: ICalendarSharingParams): IEventsListResult {
  const [eventsData, setEventData] = useState<List<IBookingEventListItemImt>>(List());
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    setIsLoading(true);
    Services.Booking.getSharingEvents(params.corporation, params)
      .then(result => setEventData(fromJS(result.data)))
      .catch(error => snackbar.error(error.message))
      .finally(() => setIsLoading(false));
  }, [params]);

  return {
    isLoading,
    data: eventsData,
  };
}
